import Swal from "sweetalert2";
import { validarEmail, postOrPutRequest, encryptData } from "../utils/utils";

const ModalRecoveryPassword = async () => {
    await Swal.fire({
        title: "Recuperar contraseña",
        input: 'email',
        inputPlaceholder: 'Ingrese su correo electrónico',
        inputValidator(value) {
            if (!value) {
                return 'Debe ingresar su correo electrónico'
            } else if (!validarEmail(value)){
                return 'Correo electrónico inválido'
            }
        },
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText:'Enviar',
        cancelButtonText: 'Cancelar',
    }).then(async (result) => {
        if (result.isConfirmed) {
            Swal.fire({
                title: 'Cargando...',
                text: 'Por favor espere',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
            let response = await postOrPutRequest(
                `auth/forgot-password`,
                'POST',
                {
                    email: encryptData(result.value),
                    origin: encryptData("app"),
                },
            );
            if (response.type === 'success') {
                Swal.fire({
                    title: response.message,
                    text: 'Hemos enviado un correo con las instrucciones para recuperar su contraseña',
                    icon: 'success',
                    confirmButtonText: 'Aceptar'
                });
            } else {
                Swal.fire({
                    title: 'Error',
                    text: ' No se pudo enviar el correo',
                    icon: 'Error',
                    confirmButtonText: 'Aceptar'
                });
            }
        }
    });
};

export default ModalRecoveryPassword;